import './App.css';
import {Route, Switch, BrowserRouter as Router} from 'react-router-dom';
import Navbar from "./components/navbar/Navbar";
import Author from "./screens/Author";
import AnalizaMain from "./screens/AnalizaMain";
import Home from "./screens/Home";
import Aplikacja from "./screens/Aplikacja";
import FirstConcepts from "./screens/PojeciaWstepne";
import Logika from "./screens/Logika";
import Kwantyfikatory from "./screens/Kwantyfikatory";
import Relacje from "./screens/Relacje";
import Nierownosci from "./screens/Nierownosci";
import DwumianNewtona from "./screens/DwumianNewtona";
import CiagiNiesk from "./screens/CiagiNiesk";
import ScrollToTop from "./ScrollToTop";
import SzeregiLiczbowe from "./screens/SzeregiLiczbowe";
import SzeregiNieujemne from "./screens/SzeregiNieujemne";
import SzeregiPrzemienne from "./screens/SzeregiPrzemienne";
import FunkcjeJednejZmiennej from "./screens/FunkcjeJednejZmiennej";
import Symetria_prosta from "./screens/Symetria_prosta";
import GraniceFunkcji from "./screens/GraniceFunkcji";
import Pochodne from "./screens/Pochodne";
import LiczbyZespolone from "./screens/LiczbyZespolone";
import SideBar from "./components/sidebar/SideBar";
import Footer from "./components/footer/Footer";
import Calki from "./screens/Calki";
import Zaawansowane from "./screens/Zaawansowane";
import SrednioZaawansowane from "./screens/SrednioZaawansowane";

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop/>
        {/*<header>
          <Navbar/>
        </header>*/}
        <header>
          <SideBar/>
        </header>

        <Switch>
          <Route path='/' exact component={Home} />
          <Route path="/analiza/pojecia-wstepne/logika" exact component={Logika} />
          <Route path="/analiza/pojecia-wstepne/kwantyfikatory" exact component={Kwantyfikatory} />
          <Route path="/analiza/pojecia-wstepne/nierownosci-1-stopnia-1" exact component={Nierownosci} />
          <Route path="/analiza/pojecia-wstepne/relacje" exact component={Relacje} />
          <Route path="/analiza/pojecia-wstepne/dwumian-Newtona" exact component={DwumianNewtona} />
          <Route path="/analiza/pojecia-wstepne/ciagi-nieskonczone" exact component={CiagiNiesk} />
          <Route path="/analiza/pojecia-wstepne/szeregi-liczbowe/nieujemne" exact component={SzeregiNieujemne} />
          <Route path="/analiza/pojecia-wstepne/szeregi-liczbowe/przemienne" exact component={SzeregiPrzemienne} />
          <Route path="/analiza/pojecia-wstepne/symetria-prosta" exact component={Symetria_prosta} />
          <Route path="/analiza/pojecia-wstepne/szeregi-liczbowe" exact component={SzeregiLiczbowe} />
          <Route path='/analiza/pojecia-wstepne' exact component={FirstConcepts} />
          <Route path='/analiza/funkcja-jednej-zmiennej' exact component={FunkcjeJednejZmiennej} />
          <Route path='/analiza/granice-funkcji' exact component={GraniceFunkcji} />
          <Route path='/analiza/pochodne' exact component={Pochodne} />
          <Route path='/analiza/liczby-zespolone' exact component={LiczbyZespolone} />
          <Route path='/analiza/calki' exact component={Calki} />
          <Route path='/analiza/zaawansowane' exact component={Zaawansowane} />
          <Route path='/analiza/srednio-zaawansowane' exact component={SrednioZaawansowane} />
          <Route path='/analiza' component={AnalizaMain} />
          <Route path='/autor' component={Author} />
          <Route path='/aplikacja' component={Aplikacja} />
        </Switch>

        <footer>
          <Footer/>
        </footer>

      </Router>
    </div>
  );
}

export default App;
